import PropTypes from 'prop-types';
import { Link } from '@evertrue/et-components';

const EmailRecipient = ({ recipient }) => {
  const contactId = recipient?.contact?.id;
  const displayName =
    recipient?.contact?.properties
      .map((prop) => {
        if (prop.name === 'name_first') {
          return prop.value;
        }
        if (prop.name === 'name_last') {
          return prop.value;
        }
      })
      .join(' ') || recipient.email_address;

  return contactId ? (
    <Link title={displayName} href={`/contact/${contactId}`}>
      {displayName}
    </Link>
  ) : (
    <span title={displayName}>{displayName}</span>
  );
};

EmailRecipient.propTypes = {
  recipient: PropTypes.object.isRequired,
};

export default EmailRecipient;
